import React from "react";

function VechileTransaction() {
  return <div>VechileTransaction</div>;
}

export default VechileTransaction;
